import { render, staticRenderFns } from "./FrkServerErrorLayout.vue?vue&type=template&id=6c4e8768&"
import script from "./FrkServerErrorLayout.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FrkServerErrorLayout.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports